import { render } from "./myFormModal.vue?vue&type=template&id=e38b2536&scoped=true&ts=true&lang=pug"
import script from "./myFormModal.vue?vue&type=script&lang=ts"
export * from "./myFormModal.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38b2536"]])

export default __exports__